(() => {
  const update = () => {
    document.querySelectorAll('[data-lv-footer-menu]').forEach(el => {
      const desktop = matchMedia('(min-width: 750px)').matches;
      if (desktop || el.dataset.accordion !== 'true') el.open = true;
      else if (el.dataset.viewport !== 'mobile') el.open = false;
      el.dataset.viewport = desktop ? 'desktop' : 'mobile';
    });
    document.querySelectorAll('.cart__ctas').forEach(el => {
      const fallback = el.querySelector('.lv-standard-checkout');
      const accelerated = el.querySelector('.additional-checkout-buttons');
      if (!fallback) return;
      const wallet = accelerated?.querySelector('shopify-accelerated-checkout-cart');
      const nativeButtons = accelerated?.querySelector('iframe, button, [role="button"]');
      const ready = (wallet && wallet.shadowRoot && wallet.shadowRoot.querySelector('button,iframe,[role="button"]')) || nativeButtons;
      const visible = ready && accelerated.getBoundingClientRect().height > 35;
      fallback.hidden = Boolean(visible);
    });
  };
  let scheduled = false;
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; update(); }); } };
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  update();
  setTimeout(update, 1500);
  setTimeout(update, 5000);
})();

if (!customElements.get('lv-cart-recommendations')) {
 customElements.define('lv-cart-recommendations', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.loaded) return;
   this.dataset.loaded = 'true';
   const url = new URL(this.dataset.url, location.origin);
   if (url.origin !== location.origin) return;
   fetch(url).then(r => { if (!r.ok) throw new Error('Recommendations unavailable'); return r.text(); }).then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('[data-lv-recommendation-results]');
    if (this.isConnected && content?.querySelector('.lv-card')) this.replaceChildren(content);
   }).catch(() => {});
  }
 });
}
